const withoutSpaces = value => value.replace(/\s+/g, '')

export const applyRule = (ruleType, ruleValue, somoraPartNumber) => {
    if (!somoraPartNumber) {
        return null
    }

    switch (ruleType) {
        case 'identity':
            return somoraPartNumber
        case 'normalize_whitespace':
            return withoutSpaces(somoraPartNumber)
        case 'strip_prefix':
            return ruleValue && somoraPartNumber.startsWith(ruleValue)
                ? somoraPartNumber.slice(ruleValue.length) || null
                : null
        case 'strip_suffix':
            return ruleValue && somoraPartNumber.endsWith(ruleValue)
                ? somoraPartNumber.slice(0, -ruleValue.length) || null
                : null
        default:
            return null
    }
}

export const examplePreview = ({ ruleType, ruleValue, exampleSomoraPartNumber, exampleTecDocPartNumber }) => {
    if (ruleType === 'exception_list' || !exampleSomoraPartNumber) {
        return null
    }

    const result = applyRule(ruleType, ruleValue, exampleSomoraPartNumber)
    const matches =
        ruleType === 'normalize_whitespace'
            ? result === withoutSpaces(exampleTecDocPartNumber || '')
            : result === exampleTecDocPartNumber

    return { result, checked: !!exampleTecDocPartNumber, matches: !!exampleTecDocPartNumber && matches }
}
